
export const WorkspacePanels = ({ insights = [] }) => (
  <>
  <section className="mt-16" data-testid="founder-insights">
    <div className="eyebrow !text-gold mb-3">Founder Insights</div>
    <p className="text-sm text-matte/60 mb-5">A short recap of each completed stage, built only from your saved answers.</p>
    {insights.length === 0 ? (
      <p className="rounded-2xl border border-dashed border-matte/15 p-6 text-sm text-matte/60" data-testid="founder-insights-empty">Complete a stage to see its recap here.</p>
    ) : (
      <div className="grid gap-4 md:grid-cols-2">
        {insights.map((i) => (
          <article key={i.stage} className="rounded-2xl bg-white border border-matte/10 p-6" data-testid={`founder-insight-${i.stage}`}>
            <div className="text-[11px] uppercase tracking-[0.28em] text-gold">{i.title}</div>
            <p className="mt-3 text-sm text-matte/80 leading-relaxed">{i.text}</p>
          </article>
        ))}
      </div>
    )}
  </section>
  </>
);
